import { useEffect } from 'react'

// If there is no scrollbar because the screen is height enough to display the initial items (12)
// we request the next page as the user couldn't scroll otherwise and we will see the never ending Loading spinner
// https://app.shortcut.com/cartoteam/story/261523/map-list-keeps-spinning
function useFixMissingScroll({ hasMoreItems, fetchMoreItems, elementSelector = 'main' }) {
  useEffect(() => {
    if (!hasMoreItems) return
    const element = document.querySelector(elementSelector)
    const hasScroll = element ? element.scrollHeight > element.clientHeight : true
    if (hasScroll) return

    const timerId = setTimeout(fetchMoreItems, 100)
    return () => clearTimeout(timerId)
  }, [hasMoreItems, fetchMoreItems, elementSelector])
}

export default useFixMissingScroll
